import React from 'react';
import PropTypes from 'prop-types';

// Components
import LoadingSpinner from '../loading-spinner';
import TopBar from './components/top-bar';
import BottomBar from 'components/forecast-demo/components/bottom-bar';
import CompareMap from './components/compare-map';
import DateInfo from './components/date-info';
import ComparingDateInfo from './components/comparing-date-info';
import ShareModal from '../share-modal';
import Legend from '../legend';


import './style.css';

class ForecastDemo extends React.Component {
  constructor(props) {
    super(props);

    this.state = { shareModalOpen: false };

    this.onClickShare = this.onClickShare.bind(this);
    this.onCloseShareModal = this.onCloseShareModal.bind(this);
    this.onChangeBasemap = this.onChangeBasemap.bind(this);
    this.onChangeLabels = this.onChangeLabels.bind(this);
    this.onViewportChanged = this.onViewportChanged.bind(this);
  }

  componentWillMount() {
    const { reset, fetchData, authentication, restoreState } = this.props;

    // We reset the store everytime
    reset();

    // We restore the state from the URL
    restoreState();

    authentication()
      .then(() => {
        fetchData();
      });
  }

  /**
   * Event handler executed when the user clicks
   * the share button
   */
  onClickShare() {
    this.setState({ shareModalOpen: true });
  }

  /**
   * Event handler executed when the user wants to close
   * the share mmodal
   */
  onCloseShareModal() {
    this.setState({ shareModalOpen: false });
  }

  /**
   * Event handlet executed when the user changes the
   * basemap
   * @param {string} id ID of the basemap
   */
  onChangeBasemap(id) {
    const { setBasemap } = this.props;
    setBasemap(id);
  }

  /**
   * Event handlet executed when the user changes the
   * labels
   * NOTE: id can be null
   * @param {string} id ID of the labels
   */
  onChangeLabels(id) {
    const { setLabels } = this.props;
    setLabels(id);
  }

  onViewportChanged(viewport) {
    const { setViewport } = this.props;
    setViewport(viewport);
  }

  render() {
    const {
      loading,
      legendValues,
      basemap,
      labels,
      language,
      selectedPollutant,
    } = this.props;
    const { shareModalOpen } = this.state;
    return (
      <div className="c-forecast-demo">
        {loading && <LoadingSpinner inner />}
        <ShareModal
          url={window.location.href}
          isOpen={shareModalOpen}
          onRequestClose={this.onCloseShareModal}
        />
        <TopBar />
        <div className="demo-map">
          <DateInfo />
          <ComparingDateInfo />
          <CompareMap
            basemap={basemap}
            labels={labels}
            language={language}
            onClickShare={this.onClickShare}
            onChangeBasemap={this.onChangeBasemap}
            onChangeLabels={this.onChangeLabels}
            onViewportChange={this.onViewportChanged}
          />
          <Legend items={legendValues} pollutant={selectedPollutant} />
        </div>
        <BottomBar />
      </div>
    );
  }
}

ForecastDemo.propTypes = {
  loading: PropTypes.bool.isRequired,
  legendValues: PropTypes.array,
  basemap: PropTypes.string.isRequired,
  labels: PropTypes.string.isRequired,
  reset: PropTypes.func.isRequired,
  authentication: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  restoreState: PropTypes.func.isRequired,
  setBasemap: PropTypes.func.isRequired,
  setLabels: PropTypes.func.isRequired,
  setViewport: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  selectedPollutant: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string,
  }),
};

ForecastDemo.defaultProps = { legendValues: [], selectedPollutant: {} };

export default ForecastDemo;



// WEBPACK FOOTER //
// ./src/components/forecast-demo/component.js